import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ProgramsGrid from './components/ProgramsGrid';
import ActivitiesGrid from './components/ActivitiesGrid';
import TestimonialsSection from './components/TestimonialsSection';
import DonationCTA from './components/DonationCTA';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <ProgramsGrid />
        <ActivitiesGrid />
        <TestimonialsSection />
        <DonationCTA />
      </main>
      <Footer />
    </>
  );
}